import * as React from 'react';
const SvgEllipsisVertical = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M11.5 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M11.5 13.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M11.5 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
    />
  </svg>
);
export default SvgEllipsisVertical;
